import { AppEnvironment } from './types'

export const Environment: AppEnvironment = {
  ENV_CODE: 'prod',
  ENV_NAME: 'Production',
  consoleLogLevel: 1,
}
